import { createAction } from '@reduxjs/toolkit';

import { getPayloadCreator } from 'app-components/flux/core/actionHelpers';

import type { AddPostponedActionPayload, PostponedActions } from './postponedActionsTypes';

export const addPostponedAction = createAction('ADD_POSTPONED_ACTION', getPayloadCreator<AddPostponedActionPayload>());
export const dispatchPostponedActions = createAction(
  'DISPATCH_POSTPONED_ACTIONS',
  getPayloadCreator<PostponedActions>(),
);
export const dismissPostponedActions = createAction('DISMISS_POSTPONED_ACTIONS', getPayloadCreator<PostponedActions>());
